import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { LoginService } from '../../Model/Login/login.service';
import { HttpClientModule } from '@angular/common/http';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonService } from '../../Model/Common/common.service';
import { NgbCarouselModule, NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgOtpInputModule } from 'ng-otp-input';
import { UtilityService } from '../../Model/utility/utility.service';
import { interval } from 'rxjs'
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterOutlet, FormsModule, CommonModule, HttpClientModule, NgbNavModule, NgOtpInputModule, NgbCarouselModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  isDisabled: boolean = false;
  active = 1;
  TabIndex = 1;
  Companys: any[] = [];
  showPassword = false;
  showForgotPassword = false;
  showConfirmPassword = false;
  showForgtoMPIN = false;
  showMPIN = false;
  timer: any;
  timingsixty = 60;
  otpButtonDisable = false;
  DomainDetail = {
    Domain: null as any,
  }
  isCheckLoginDetail = false;
  IsForgotPassword = true;

  UserDetail = {
    UserId: null,
    UserName: null as any,
    // EDesignation: null,
    // EPhoto: null,
    EmpType: null,
    EmpCode: null,
    TokenAppName: null,
    TokenUserName: null,
    TokenPassword: null,
    Token: null,
    UserType: 'E' as any,
    OpType: 'Login' as any,
    LoginType: 'P' as any,
    OtpGenerated: false as any,
    SessionID: null as any,
    LoginName: null as any,
    Password: null,
    UserEnterdOTP: null as any,
    CompanyMasterId: null,
    CompanyName: null,
    CompanyCode: null,
    Domain: null,
    IsPreOnBoarding: false,
    TimeStamp: null,
    CompanyLogo: null as any,
    ApiUrl: null as any,
    primaryUrl: null as any,
    secondaryUrl: null as any,
    Date: null as any,
    selectedmenuID: 0,
    menuname: null,
    first: true,
    U_UserType: null,
    MPIN: null as any,
    //UserEnterdMPIN:null,
    //IsMpinEnable:false
    IsMPINSet: false,
    IsPasswordSet: false,
    IsPopFirstTimeMpin: true,
    AdministrationURL: '',
    Module: null,
  }

  ForgotPasswordDetail = {
    Password: null,
    ConfirmPassword: null,
  }

  ForgotMPIDetail = {
    MPIN: null as any,
  }

  constructor(
    private login: LoginService,
    private toast: ToastService,
    private session: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private common: CommonService,
    private utility: UtilityService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
  ) {
    this.route.queryParams.subscribe(params => {
      this.UserDetail.TimeStamp = params['Tid'];
      this.DomainDetail.Domain = params['Did'];
    });
  }

  ngOnInit(): void {
    if (this.getCookie('MaxEdgeDomain') != '' && this.UserDetail.TimeStamp == null) {
      this.DomainDetail.Domain = this.getCookie('MaxEdgeDomain');
      this.GetCredentials();
      //this.getUserCookie();
    } else {
      if (this.UserDetail.TimeStamp == null) {
        this.TabIndex = 0;
      } else {
        this.UserDetail.IsPreOnBoarding = true
        this.UserDetail.LoginType = 'O';
        this.isCheckLoginDetail = true;
        this.GetCredentials();
      }
    }
    this.UserDetail.Date = new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear();
  }

  DomainValidate(form: any) {
    if (form.valid) {
      this.GetCredentials();
    }
    else {
      form.submitted = true;
    }
  }

  LoginValidate(form: any) {
    if (form.valid) {
      if (this.UserDetail.LoginType == 'O' && this.UserDetail.UserEnterdOTP.length != 6) {
        this.toast.show({ message: 'Please enter otp', type: toastTypeEnum.warning });
      } else {
        if (this.isCheckLoginDetail || this.UserDetail.UserType == 'A') {
          this.LoginCheck();
        } else {
          this.ESS_GetLoginDetails();
        }
      }
    }
    else {
      form.submitted = true;
    }
  }

  CompanyValidate(form: any) {
    if (form.valid) {
      this.Save();
    }
    else {
      form.submitted = true;
    }
  }

  ForgotPasswordOneValidate(form: any) {
    if (form.valid) {
      this.LoginCheck();
    }
    else {
      form.submitted = true;
    }
  }

  ForgotPasswordTwoValidate(form: any) {
    if (form.valid) {
      if (this.IsForgotPassword) {
        this.SaveForgotPassword();
      } else {
        this.Mobile_ESS_Get_LocalAuthDetails();
      }
    }
    else {
      form.submitted = true;
    }
  }

  GetCredentials() {
    this.isDisabled = true;
    this.login.GetCredentials(this.DomainDetail).subscribe({
      next: async (response) => {
        if (response.Domain_Check != undefined && response.Domain_Check.length > 0) {
          this.UserDetail.TokenAppName = response.Domain_Check[0].AppName;
          this.UserDetail.TokenUserName = response.Domain_Check[0].UserName;
          this.UserDetail.TokenPassword = response.Domain_Check[0].Password;
          this.UserDetail.CompanyLogo = response.Domain_Check[0].CompanyLogoPath;
          this.UserDetail.Domain = this.DomainDetail.Domain;
          //this.UserDetail.ApiUrl = (response.Domain_Check[0].PrimaryAPIUrl == '' || response.Domain_Check[0].PrimaryAPIUrl == null) ? response.Domain_Check[0].ApiUrl : response.Domain_Check[0].PrimaryAPIUrl;
          this.UserDetail.ApiUrl = response.Domain_Check[0].ApiUrl;
          //this.UserDetail.primaryUrl = response.Domain_Check[0].PrimaryAPIUrl;
          this.UserDetail.primaryUrl = response.Domain_Check[0].ApiUrl;
          this.UserDetail.secondaryUrl = response.Domain_Check[0].ApiUrl;
          this.UserDetail.AdministrationURL = response.Domain_Check[0].AdministrationURL;
          if (!this.UserDetail.IsPreOnBoarding) {
            this.setCookie('MaxEdgeDomain', this.DomainDetail.Domain, 30);
          }
          if (this.session.GetUserDetails() != null) {
            this.Auth();
          } else {
            if (await this.session.Start(this.UserDetail)) {
              this.Auth();
            }
          }

        } else {
          if (this.TabIndex != 0) {
            this.TabIndex = 0;
          }
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
          this.isDisabled = false;
        }
      },
      complete: () => {
        //this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Auth() {
    this.isDisabled = true;
    this.login.Auth({ 'UserName': this.UserDetail.TokenUserName, 'PassWord': this.UserDetail.TokenPassword, 'AppName': this.UserDetail.TokenAppName }, this.UserDetail.ApiUrl).subscribe({
      next: (response) => {
        if (response.Error_Code == "01") {
          this.UserDetail.Token = response.Auth_token_no;
          this.TabIndex = 1;
          if (this.UserDetail.IsPreOnBoarding) {
            this.Ess_Link_ExpiryCheck();
          } else {
            if (this.session.GetUserDetails() != null) {
              if (this.session.GetUserDetails().UserId > 0) {
                this.common.CompanyParameter();
                if (this.session.GetUserDetails().UserType == 'A') {
                  //this.router.navigate(['module'], { replaceUrl: true });
                  this.router.navigate(['dashboard/front'], { replaceUrl: true });
                } else if (this.session.GetUserDetails().UserType == 'E') {
                  this.router.navigate(['home/'], { replaceUrl: true });
                }
              }
            }
          }
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoginCheck() {
    this.isDisabled = true;
    this.login.LoginCheck(this.UserDetail, this.UserDetail.ApiUrl).subscribe({
      next: (response) => {
        if (response.Error_Code == "10") {
          this.UserDetail.SessionID = response.SessionID;
          this.UserDetail.UserId = response.UserMasterId;
          this.UserDetail.UserName = response.UserName;
          // this.UserDetail.EDesignation = response.EDesignation;
          this.UserDetail.EmpCode = response.EmpCode;
          // this.UserDetail.EPhoto = response.EPhoto;
          this.UserDetail.EmpType = response.EmpType;
          this.UserDetail.CompanyCode = response.CompanyCode;
          this.UserDetail.CompanyName = response.CompanyName;
          this.UserDetail.U_UserType = response.U_UserType;
          if (this.TabIndex == 1) {
            if (this.UserDetail.UserType == 'A') {
              this.GetCompany();
              this.TabIndex = 2
            } else {
              this.Save();
            }
          } else if (this.TabIndex == 3) {
            this.TabIndex = 4;
          }

        } else if (response.Error_Code == "02") {
          if (this.getCookie('MaxEdgeDomain') != '' && this.UserDetail.TimeStamp == null) {
            this.DomainDetail.Domain = this.getCookie('MaxEdgeDomain');
            this.GetCredentials();
          } else {
            if (this.UserDetail.TimeStamp == null) {
              this.TabIndex = 0;
            } else {
              this.UserDetail.IsPreOnBoarding = true
              this.UserDetail.LoginType = 'O';
              this.GetCredentials();
            }
          }
          //this.LoginCheck();
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetCompany() {
    this.isDisabled = true;
    this.login.GetCompany(this.UserDetail, this.UserDetail.ApiUrl).subscribe({
      next: (response) => {
        this.Companys = response.CompanySelection;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GenerateOTP() {
    if (this.UserDetail.LoginName != null && this.UserDetail.LoginName.toString().trim() != "") {
      this.isDisabled = true;
      this.otpButtonDisable = true;
      this.login.GenerateOTP({ TokenUserName: this.UserDetail.TokenUserName, TokenPassword: this.UserDetail.TokenPassword, TokenAppName: this.UserDetail.TokenAppName, Token: this.UserDetail.Token, LoginName: this.UserDetail.LoginName, UserType: this.UserDetail.UserType, IsPreOnBoarding: this.UserDetail.IsPreOnBoarding, TimeStamp: this.UserDetail.TimeStamp }, this.UserDetail.ApiUrl).subscribe({
        next: (response) => {
          if (response.Error_Code == '01') {
            this.timingsixty = 60;
            this.UserDetail.LoginType = 'O';
            this.UserDetail.OtpGenerated = true;
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
            this.timer = interval(1000).subscribe((val) => {
              this.timingsixty -= 1;
              if (this.timingsixty == 0) {
                this.otpButtonDisable = false;
                this.timer.unsubscribe();
              }
            });

          } else {
            this.otpButtonDisable = false;
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.otpButtonDisable = false;
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: 'Please enter mobileno/email id', type: toastTypeEnum.warning });
    }
  }

  async Save() {
    this.UserDetail.LoginType = null;
    this.UserDetail.OtpGenerated = null;
    //this.UserDetail.LoginName = null;
    this.UserDetail.Password = null;
    this.UserDetail.UserEnterdOTP = null;
    this.UserDetail.MPIN = null;
    if (this.UserDetail.UserType == 'A') {
      if (this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.UserDetail.CompanyMasterId)].CompanyLogoPath != null && this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.UserDetail.CompanyMasterId)].CompanyLogoPath != "") {
        this.UserDetail.CompanyLogo = this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.UserDetail.CompanyMasterId)].CompanyLogoPath;
      }
      this.UserDetail.CompanyCode = this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.UserDetail.CompanyMasterId)].CompanyCode;
      this.UserDetail.CompanyName = this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.UserDetail.CompanyMasterId)].CompanyName;
      this.common.selectedmenuID = 1;
    } else {
      if (!this.UserDetail.IsPreOnBoarding) {
        this.common.selectedmenuID = 2;
      }
    }
    if (await this.session.Start(this.UserDetail)) {
      if (!this.UserDetail.IsPreOnBoarding) {
        await this.common.CompanyParameter();
        if (this.UserDetail.UserType == 'A') {
          this.DbNameWithSessionInsret();
        } else {
          this.router.navigate(['home/'], { replaceUrl: true });
        }
      } else {
        this.router.navigate(['preonboarding/add/' + this.UserDetail.UserId + '/' + true], { replaceUrl: true });
      }
    }
    this.isDisabled = true;
  }

  DbNameWithSessionInsret() {
    this.isDisabled = true;
    this.login.DbNameWithSessionInsret({ OpType: 'U', SessionId: this.UserDetail.SessionID, DbName: this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.UserDetail.CompanyMasterId)].DBName }, this.UserDetail.ApiUrl).subscribe({
      next: (response) => {
        if (response.Error_Code == '01') {
          //this.router.navigate(['module'], { replaceUrl: true });
          this.router.navigate(['dashboard/front'], { replaceUrl: true });
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  togglePasswordVisibility(Flag: number) {
    if (Flag == 1) {
      this.showPassword = !this.showPassword;
    } else if (Flag == 2) {
      this.showForgotPassword = !this.showForgotPassword;
    } else if (Flag == 3) {
      this.showConfirmPassword = !this.showConfirmPassword;
    } else if (Flag == 4) {
      this.showMPIN = !this.showMPIN;
    } else if (Flag == 5) {
      this.showForgtoMPIN = !this.showForgtoMPIN;
    }
  }

  ForgotPassword() {
    this.TabIndex = 3;
    if (this.UserDetail.LoginType == 'P') {
      this.IsForgotPassword = true;
    } else {
      this.IsForgotPassword = false;
    }
    if (this.UserDetail.LoginName != null && this.UserDetail.LoginName != '') {
      this.GenerateOTP();
    }
  }

  SaveForgotPassword() {
    if (this.ForgotPasswordDetail.Password == this.ForgotPasswordDetail.ConfirmPassword) {
      this.isDisabled = true;
      this.login.SaveForgotPassword({ LoginName: this.UserDetail.LoginName, Password: this.ForgotPasswordDetail.Password, OTPGenerated: this.UserDetail.UserEnterdOTP, IsPreOnBoarding: this.UserDetail.IsPreOnBoarding, UserId: this.UserDetail.UserId, TokenUserName: this.UserDetail.TokenUserName, TokenPassword: this.UserDetail.TokenPassword, TokenAppName: this.UserDetail.TokenAppName, Token: this.UserDetail.Token, SessionID: this.UserDetail.SessionID, OpType: this.UserDetail.OpType, UserType: this.UserDetail.UserType }, this.UserDetail.ApiUrl).subscribe({
        next: (response) => {
          if (response.Error_Code == "01") {
            this.UserDetail.LoginType = 'P';
            this.UserDetail.OtpGenerated = false;

            this.UserDetail.SessionID = null;
            this.UserDetail.UserId = null;
            this.UserDetail.UserName = null;
            this.UserDetail.CompanyCode = null;
            this.UserDetail.CompanyName = null;
            this.TabIndex = 1;
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
          }

          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: 'Password and confirm password missmatch.', type: toastTypeEnum.warning });
    }
  }

  private setCookie(name: string, value: string, expireDays: number, path: string = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    window.document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  BackLogin() {
    this.TabIndex = 1;
  }

  LoginUsingToggle() {
    if (this.UserDetail.UserType == 'A') {
      this.UserDetail.LoginType = this.UserDetail.LoginType == 'P' ? 'O' : 'P';
      if (this.UserDetail.LoginType == 'O' && this.UserDetail.LoginName != null && this.UserDetail.LoginName != '') {
        this.GenerateOTP();
      }
    } else {
      this.UserDetail.LoginType = this.UserDetail.LoginType == 'P' ? 'MPIN' : 'P';
    }
  }

  onOtpChange(event: any) {
    this.UserDetail.UserEnterdOTP = event;
    if (this.UserDetail.LoginName != null && this.UserDetail.LoginName != '' && this.UserDetail.UserEnterdOTP != null && this.UserDetail.UserEnterdOTP.length == 6) {
      this.LoginCheck();
    }
  }

  onMpinChange(event: any) {
    this.UserDetail.MPIN = event;
    if (this.UserDetail.LoginName != null && this.UserDetail.LoginName != '' && this.UserDetail.MPIN != null && this.UserDetail.MPIN.length == 4) {
      this.LoginCheck();
    }
  }

  onForgotMpinChange(event: any) {
    this.ForgotMPIDetail.MPIN = event;
  }

  // onMPINChange(event: any) {
  //   this.UserDetail.UserEnterdMPIN = event;
  // }

  LoginChange(event: any) {
    if (event.nextId == 1) {
      this.UserDetail.UserType = 'E';
    } else if (event.nextId == 2) {
      this.UserDetail.UserType = 'A';
    }
    this.UserDetail.UserEnterdOTP = false;
    this.UserDetail.OtpGenerated = false;
    this.UserDetail.UserEnterdOTP = null;
  }

  Ess_Link_ExpiryCheck() {
    this.isDisabled = true;
    this.login.Ess_Link_ExpiryCheck({ IsPreOnBoarding: this.UserDetail.IsPreOnBoarding, SelectType: '', LoginName: '', TimeStamp: this.UserDetail.TimeStamp, 'TokenUserName': this.UserDetail.TokenUserName, 'TokenPassword': this.UserDetail.TokenPassword, 'TokenAppName': this.UserDetail.TokenAppName, 'Token': this.UserDetail.Token, 'SessionID': this.UserDetail.SessionID, 'OpType': this.UserDetail.OpType, 'UserType': this.UserDetail.UserType }, this.UserDetail.ApiUrl).subscribe({
      next: (response) => {
        if (response.length > 0 && response[0].EmpMasterId > 0) {
          if (this.common.ToLowerCase(response[0].URLStatus) != 'active') {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.showOk = false;
            modalRef.componentInstance.Message = "Link Expired";
            modalRef.result.then((result: any) => { });
          }
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.showOk = false;
          modalRef.componentInstance.Message = "Link Expired";
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // getUserCookie() {
  //   const jsonData = this.getCookie('MaxEdgeUserdata');
  //   if (jsonData) {
  //     const data = JSON.parse(jsonData);
  //     this.UserDetail.EmpCode = data.EmpCode;
  //     this.UserDetail.UserType = data.UserType;
  //     this.UserDetail.EPhoto = data.EPhoto;
  //     this.UserDetail.UserName = data.UserName;
  //     this.UserDetail.IsMpinEnable = true
  //   }
  // }

  getInitial(text: String) {
    if (text != null) {
      const stext = text.split(' ').map(name => name[0]).join('').toUpperCase();
      return stext.charAt(0) + stext.charAt(stext.length - 1);
    } else {
      return '';
    }
  }

  ESS_GetLoginDetails() {
    this.isDisabled = true;
    this.login.ESS_GetLoginDetails({ SelectType: 'AuthInfo', LoginName: this.UserDetail.LoginName, TokenUserName: this.UserDetail.TokenUserName, TokenPassword: this.UserDetail.TokenPassword, TokenAppName: this.UserDetail.TokenAppName, Token: this.UserDetail.Token, SessionID: this.UserDetail.SessionID, OpType: this.UserDetail.OpType, UserType: this.UserDetail.UserType }, this.UserDetail.ApiUrl).subscribe({
      next: (response) => {
        if (response && response.Table.length > 0) {
          if (response.Table[0].EmpMasterId > 0) {
            this.isCheckLoginDetail = true;
            this.UserDetail.IsMPINSet = (response.Table[0].IsMPINSet == 1 && response.Table[0].IsMPINEnabled);
            this.UserDetail.IsPasswordSet = (response.Table[0].IsPasswordSet == 1);
            if (response.Table[0].IsMPINSet == 1 && response.Table[0].IsMPINEnabled) {
              this.UserDetail.LoginType = 'MPIN'
            } else if (response.Table[0].IsPasswordSet == 1) {
              this.UserDetail.LoginType = 'P'
            } else {
              this.UserDetail.LoginType = 'O'
              this.GenerateOTP();
            }
          } else {
            this.toast.show({ message: 'Login Detail Not Found', type: toastTypeEnum.warning });
          }
        } else {
          this.toast.show({ message: 'Login Detail Not Found', type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  resetLoginCheckDetail() {
    if (this.isCheckLoginDetail && !this.UserDetail.IsPreOnBoarding) {
      this.isCheckLoginDetail = false;
      this.UserDetail.IsMPINSet = false;
      this.UserDetail.IsPasswordSet = false;
      this.UserDetail.LoginType = 'P';
    }
  }

  Mobile_ESS_Get_LocalAuthDetails() {
    this.isDisabled = true;
    this.utility.Mobile_ESS_Get_LocalAuthDetailsFromLogin({
      'SelectType': 'S', 'EmpMasterId': this.UserDetail.UserId, 'TokenUserName': this.UserDetail.TokenUserName, 'TokenPassword': this.UserDetail.TokenPassword, 'TokenAppName': this.UserDetail.TokenAppName, 'Token': this.UserDetail.Token, 'SessionID': this.UserDetail.SessionID, 'OpType': this.UserDetail.OpType, 'UserType': this.UserDetail.UserType, 'UserId': this.UserDetail.UserId,
    }, this.UserDetail.ApiUrl).subscribe({
      next: (mresponse) => {
        mresponse = JSON.parse(mresponse);
        if (mresponse && mresponse.Table.length > 0) {
          if (this.ForgotMPIDetail.MPIN != null && this.ForgotMPIDetail.MPIN != '' && this.ForgotMPIDetail.MPIN.length == 4) {
            this.isDisabled = true;
            this.utility.Mobile_ESS_Update_LocalAuthUpdateFromLogin({
              SelectType: 'U',
              EmpMasterId: this.UserDetail.UserId,
              OneTime_LocalAuthOption: mresponse.Table[0].OneTime_LocalAuthOption,
              IsFingerPrintEnabled: mresponse.Table[0].IsFingerPrintEnabled,
              IsMPINEnabled: mresponse.Table[0].IsMPINEnabled,
              MPIN: this.ForgotMPIDetail.MPIN,
              'TokenUserName': this.UserDetail.TokenUserName, 'TokenPassword': this.UserDetail.TokenPassword, 'TokenAppName': this.UserDetail.TokenAppName, 'Token': this.UserDetail.Token, 'SessionID': this.UserDetail.SessionID, 'OpType': this.UserDetail.OpType, 'UserType': this.UserDetail.UserType, 'UserId': this.UserDetail.UserId,
            }, this.UserDetail.ApiUrl).subscribe({
              next: (response) => {
                response = JSON.parse(response);
                if (response.ErrorCode == '446') {
                  this.UserDetail.LoginType = 'MPIN';
                  this.UserDetail.OtpGenerated = false;

                  this.UserDetail.SessionID = null;
                  this.UserDetail.UserId = null;
                  this.UserDetail.UserName = null;
                  this.UserDetail.CompanyCode = null;
                  this.UserDetail.CompanyName = null;
                  this.TabIndex = 1;
                  this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => {
                return true
              },
              error: (err) => {
                this.isDisabled = false;
                return false;
              }
            })
          } else {
            this.toast.show({ message: "Plase enter 4 digit MPIN", type: toastTypeEnum.danger });
          }
          // this.data.EmpMasterId = this.user.UserId;
          // this.data.OneTime_LocalAuthOption = response.Table[0].OneTime_LocalAuthOption;
          // this.data.IsFingerPrintEnabled = response.Table[0].IsFingerPrintEnabled;
          // this.data.IsMPINEnabled = response.Table[0].IsMPINEnabled;
          // this.data.MPIN = response.Table[0].MPIN;
          // if(this.data.MPIN != null){
          //   this.ngOtpInput.setValue(this.data.MPIN);
          // }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }
}
